/* NOVARIS Gift: card add-to-cart (opens the theme cart drawer) and muted autoplay of reel videos while visible. */
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-ng-atc]');
    if (!form) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return; // no drawer: normal form post to /cart
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var label = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    var body = new FormData(form);
    body.append('sections', 'cart-drawer,cart-icon-bubble');
    body.append('sections_url', window.location.pathname);
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          btn.textContent = res.description || res.message || 'Could not add';
          setTimeout(function () { btn.textContent = label; }, 2500);
          return;
        }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ng-card', productVariantId: body.get('id'), cartData: res });
        }
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
  });

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initReels() {
    var vids = document.querySelectorAll('.ng-reel video');
    if (!vids.length || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && en.intersectionRatio >= 0.5) {
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: [0, 0.5] });
    vids.forEach(function (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      io.observe(v);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReels);
  else initReels();
  document.addEventListener('shopify:section:load', initReels);
})();
